import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from '../supabase/supabaseClient';
import Home from "../Pages/Home";
import Loader from "./ReusableComponents/Loader";

const ProtectedGeneratorRoute = ({ darkMode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkSubscriptionAndRoute = async () => {

      // If still loading auth, wait
      if (loading) {
        setIsChecking(true);
        return;
      }

      // Check if user has subscription
      // Check if user has subscription or active license
      let isSubscribed = false;
      if (user) {
        try {
          // Check subscription using customer_email (not user_id)
          const { data: subscriptionData, error: subError } = await supabase
            .from('subscriptions')
            .select('status')
            .eq('customer_email', user.email)
            .in('status', ['active', 'on_trial', 'past_due'])
            .maybeSingle();

          if (!subError && subscriptionData) {
            isSubscribed = true;
          } else {
            // Check for active 24-hour license
            const { data: licenseData, error: licenseError } = await supabase
              .from('user_licenses')
              .select('expires_at')
              .eq('user_id', user.id)
              .gt('expires_at', new Date().toISOString())
              .maybeSingle();

            if (!licenseError && licenseData) {
              isSubscribed = true;
            }
          }
        } catch (error) {
          console.error('Error checking subscription/license:', error);
        }
      }

      // Check if URL has multiple colors
      const path = location.pathname;
      const hasDuoColor = path.includes('&D');
      const hasTrioColor = path.includes('&T');

      // If no subscription but URL has multiple colors, strip them
      if (!isSubscribed && (hasDuoColor || hasTrioColor)) {
        const monoColorMatch = path.match(/\/generator\/([a-fA-F0-9]{6})/);

        if (monoColorMatch) {
          const monoColor = monoColorMatch[1];
          // Redirect to mono-only URL
          navigate(`/generator/${monoColor}`, { replace: true });
        } else {
          // If can't parse, just go to base generator
          navigate('/generator', { replace: true });
        }
      }

      setIsChecking(false);
    };

    checkSubscriptionAndRoute();
  }, [user, loading, location.pathname, navigate]);

  // Show loader while checking
  if (isChecking) {
    return <Loader />;
  }

  return <Home darkMode={darkMode} />;
};

export default ProtectedGeneratorRoute;